/**
 * dcent-image-compare.js — Phase 48 신규 공유 컴포넌트.
 *
 * before/after 드래그 비교 슬라이더. pointer 이벤트로 clientX → % 를 계산해
 * 각 인스턴스 요소의 --compare-pos CSS 변수를 갱신한다(다중 인스턴스 안전, 전역 상태 0).
 * 소스: ~/work/homepage-design-src/src/components/ImageCompare.tsx (L15-21 update, L44 clip).
 *
 * Markup:
 *   <div class="dcent-image-compare" style="--compare-pos: 50%">
 *     <img class="dcent-image-compare__img dcent-image-compare__after" ...>
 *     <div class="dcent-image-compare__before"><img class="dcent-image-compare__img" ...></div>
 *     <div class="dcent-image-compare__handle">...</div>
 *   </div>
 */

export function initImageCompare(root = document) {
  root.querySelectorAll(".dcent-image-compare").forEach((el) => {
    if (el.dataset.imageCompareReady === "true") return;
    el.dataset.imageCompareReady = "true";

    let dragging = false;

    const update = (clientX) => {
      const rect = el.getBoundingClientRect();
      if (rect.width === 0) return;
      const pct = ((clientX - rect.left) / rect.width) * 100;
      const clamped = Math.max(0, Math.min(100, pct));
      el.style.setProperty("--compare-pos", clamped + "%");
    };

    /* drop-03 W2-3 — 터치 방향 판별(원본 ImageCompare.tsx L29-72 이식).
       마우스는 종전 그대로 즉시 드래그다. 터치는 시작점을 기억해 두고 6px 을 넘긴 뒤에야
       방향을 정한다: 가로가 크면 drag(포인터 캡처 + update), 세로가 크면 scroll 로 확정해
       브라우저에 양보한다. 이게 없으면 슬라이더 위에서 페이지를 세로로 못 넘긴다. */
    const TOUCH_SLOP = 6;
    let mode = null; // null=미정 | "drag" | "scroll"
    let startX = 0;
    let startY = 0;

    el.addEventListener("pointerdown", (e) => {
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      if (e.pointerType === "touch") {
        mode = null; // 방향이 정해질 때까지 아무것도 하지 않는다
        return;
      }
      mode = "drag";
      if (typeof el.setPointerCapture === "function") {
        el.setPointerCapture(e.pointerId);
      }
      update(e.clientX);
    });

    el.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      if (mode === null) {
        const dx = Math.abs(e.clientX - startX);
        const dy = Math.abs(e.clientY - startY);
        if (dx < TOUCH_SLOP && dy < TOUCH_SLOP) return;
        mode = dx > dy ? "drag" : "scroll";
        if (mode === "drag" && typeof el.setPointerCapture === "function") {
          el.setPointerCapture(e.pointerId);
        }
      }
      if (mode === "drag") update(e.clientX);
    });

    const stop = () => {
      dragging = false;
      mode = null;
    };
    el.addEventListener("pointerup", stop);
    el.addEventListener("pointercancel", stop);
  });
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  document.addEventListener("DOMContentLoaded", () => initImageCompare());
}
